// extracted by mini-css-extract-plugin
module.exports =  {"location":"IoqPbe"};